module.exports = __webpack_public_path__ + "img/gongshui2.ae0a4b4e.png";